import { styled } from 'parkdepot-shared/theme'

const DisabledMapWrapper = styled('div', ({ $theme }) => ({
    height: 'calc(100vh - 20rem)',
    position: 'relative',
    backgroundColor: $theme.colors.white,
    padding: '4rem',

    [$theme.mediaQuery.large]: {
        width: '100%',
        borderRadius: '2.4rem',
        overflow: 'hidden'
    }
}))

export const DisabledMapText = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    textAlign: 'center',

    [$theme.mediaQuery.large]: {
        maxWidth: '50rem',
        margin: '0 auto'
    }
}))

export const ButtonContainer = styled('div', ({ $theme }) => ({
    textAlign: 'center',
    marginTop: '4rem'
}))

export default DisabledMapWrapper
